import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

const Hero = styled.div`
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  padding: 6rem 2rem;
  color: white;
  text-align: center;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
`;

export { PageContainer, Hero, Content };